import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';

const styles = () => ({
  root: {},
});

const EnterOnlyInput = ({
  className,
  classes,
  error,
  label,
  value,
  test,
  onChange,
  helperText,
  endAdornment,
  InputComponent,
}) => {
  return (
    <TextField
      className={classNames(className, classes.root)}
      error={error}
      label={label}
      onChange={onChange}
      helperText={helperText}
      test={test}
      value={value}
      InputProps={{
        endAdornment,
        inputComponent: InputComponent,
      }}
    />
  );
};

EnterOnlyInput.defaultProps = {
  className: '',
  value: '',
  helperText: null,
  test: null,
  error: null,
  endAdornment: null,
  InputComponent: undefined,
};

EnterOnlyInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  test: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  endAdornment: PropTypes.object,
  InputComponent: PropTypes.object,
};

export default withStyles(styles)(EnterOnlyInput);
